import React from "react";
import {
  MessagesBackground,
  MessageWrapper,
  MessageBox,
  MessageAuthor,
  MessageText,
  MessageTimestamp,
} from "./ConversationMessages.styles";
import { EmptyStateMessage } from "../InfoSection/InfoSection.styles";

export const ConversationMessages = ({ conversationData, t }) => {
  const safeConversationData = Array.isArray(conversationData) ? conversationData : [];
  
  return (
    <MessagesBackground>
      {safeConversationData.length === 0 ? (
        <EmptyStateMessage>{t("logs.noConversationData")}</EmptyStateMessage>
      ) : (
        safeConversationData.map((message, index) => {
          const { sender, isClient } = message;
          return (
            <MessageWrapper key={message.id || index} $isClient={isClient}>
              <MessageBox $isClient={isClient}>
                <MessageAuthor>{sender}</MessageAuthor>
                <MessageText>{message.content}</MessageText>
                <MessageTimestamp>{`${message.date}`}</MessageTimestamp>
              </MessageBox>
            </MessageWrapper>
          );
        })
      )}
    </MessagesBackground>
  );
};
